import { z } from "zod";
import { assertNever } from "../../assert-never";
import {
    storageItemImageReferenceFactory,
    storageItemImageReferenceZodObject,
} from "../storage-item-images/storage-item-image-reference";
import {
    storageItemPdfReferenceFactory,
    storageItemPdfReferenceZodObject,
} from "../storage-item-pdfs/storage-item-pdf-reference";
import {
    storageItemSvgReferenceFactory,
    storageItemSvgReferenceZodObject,
} from "../storage-item-svgs/storage-item-svg-reference";

const storageItemReferenceZodObject = z.discriminatedUnion("type", [
    storageItemImageReferenceZodObject,
    storageItemPdfReferenceZodObject,
    storageItemSvgReferenceZodObject,
]);
type StorageItemReference = z.infer<typeof storageItemReferenceZodObject>;
const storageItemReferenceZodSchema: z.ZodSchema<StorageItemReference> =
    storageItemReferenceZodObject;

const storageItemReferenceFactory = (type: StorageItemReference["type"]) => {
    switch (type) {
        case "IMAGE":
            return storageItemImageReferenceFactory;
        case "PDF":
            return storageItemPdfReferenceFactory;
        case "SVG":
            return storageItemSvgReferenceFactory;
        default:
            assertNever(type);
    }
};

const isStorageItemReference = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reference: any
): reference is StorageItemReference => {
    if (typeof reference === "undefined") return false;
    return reference._type === "STORAGE_ITEM_REFERENCE";
};

export type { StorageItemReference };
export {
    storageItemReferenceFactory,
    isStorageItemReference,
    storageItemReferenceZodSchema,
    storageItemReferenceZodObject,
};
